interface LearningExercisesElement extends HTMLElement {
  startLearningExercises?: () => Promise<void>
}

up.compiler(
  '[data-learning-exercises]',
  (element: LearningExercisesElement, { lazy = false }: { lazy?: boolean | string }) => {
    let started = false

    const startLearningExercises = async () => {
      if (!started) {
        started = true
        const { mountLearningExercises } =
          await import('frontend/unpoly/javascripts/learning_exercises/component')

        if (element.isConnected) {
          const destroy = mountLearningExercises(element)
          up.destructor(element, destroy)
        }
      }
    }

    element.startLearningExercises = startLearningExercises

    if (!lazy || lazy === 'false') {
      void startLearningExercises()
    }
  },
)
